import React from "react";
import PropTypes from "prop-types";

import Type from "./type";

import * as S from "./styled";

function Modal({ active, children, className, onClose, title }) {
  return (
    <S.ModalWrapper className={`${className} ${active ? "--active" : ""}`}>
      <S.ModalContainer>
        <S.ModalHeader>
          <S.ModalTitle>{title}</S.ModalTitle>
          <S.ModalTogglerButton onClick={onClose}>x</S.ModalTogglerButton>
        </S.ModalHeader>
        <S.ModalBody>{children}</S.ModalBody>
      </S.ModalContainer>
    </S.ModalWrapper>
  );
}

Modal.defaultProps = { className: "" };
Modal.propTypes = {
  ...Type,
  children: PropTypes.node.isRequired,
};

export default Modal;
